import script from "./Phone.step.vue?vue&type=script&setup=true&lang=js"
export * from "./Phone.step.vue?vue&type=script&setup=true&lang=js"

import "./Phone.step.vue?vue&type=style&index=0&id=13ec9666&lang=scss"

const __exports__ = script;

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QFooter from 'quasar/src/components/footer/QFooter.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QFooter,QBtn});
